import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("agri_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("agri_token", t);
  else localStorage.removeItem("agri_token");
};

export const getToken = () => localStorage.getItem("agri_token");

// Signal helpers
export const signalClass = (sig) =>
  ({ BUY: "signal-buy", HOLD: "signal-hold", WAIT: "signal-wait" }[sig] || "signal-hold");

export const changeColor = (v) =>
  v > 0 ? "text-[hsl(var(--signal-buy))]" : v < 0 ? "text-[hsl(var(--signal-wait))]" : "text-muted-foreground";

export const fmtPrice = (v, digits = 2) =>
  v === null || v === undefined ? "—" : Number(v).toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });

export const fmtPct = (v) => (v === null || v === undefined ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(2)}%`);
